import {service} from '.';
import { cookies } from 'static';

const getToken = () => {
  const stored = localStorage.getItem(cookies.FarmersPlanToken);
  return stored ? JSON.parse(stored)?.token : undefined;
};

export const getAllCountries = () => service('/api/v1/countries/all', {method: 'GET'}, getToken());
